
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSortArrowNotSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  viewBox: "0 0 12 8"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icons-sort-arrow-not-select_4b102330daff286c__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icons-sort-arrow-not-select_4b102330daff286c__a)",
  transform: "translate(0 -6)",
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.628
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B3B3B3",
  d: "m6.76 13.114 3.825-4.463A1 1 0 0 0 9.826 7H2.174a1 1 0 0 0-.759 1.65l3.826 4.464a1 1 0 0 0 1.518 0z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"8\" viewBox=\"0 0 12 8\">\r\n    <defs>\r\n        <filter id=\"clpjx1m46a\">\r\n            <feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0\"/>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\".628\">\r\n        <g>\r\n            <g filter=\"url(#clpjx1m46a)\" transform=\"translate(-19 -210) translate(19 204)\">\r\n                <g>\r\n                    <path fill=\"#B3B3B3\" d=\"M6.76 1.886l3.825 4.463c.36.42.31 1.05-.108 1.41-.182.156-.413.241-.651.241H2.174c-.552 0-1-.448-1-1 0-.239.086-.47.241-.65l3.826-4.464c.36-.42.99-.468 1.41-.109.039.034.075.07.108.109z\" transform=\"translate(0 6) matrix(1 0 0 -1 0 9)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-sort-arrow-not-select.4b102330daff286c139ec8cbeb66fe11.svg"),
        {
          React: SvgIconsSortArrowNotSelect,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      